import type { OrganisationInterface } from '@/types'

const REQUIRED_ORGANISATION_UPDATE_FIELDS = [
  'description',
  'vatNumber',
  'fullLegalName',
  'shortLegalName',
  'legalAddress',
  'postalAddress',
  'phoneNumber',
  'contactPhone',
  'email',
  'emailDistribution',
  'signatoryFullName',
  'signatoryPosition',
  'signatoryOperatesUnder',
] as const satisfies readonly (keyof OrganisationInterface)[]

export const withRequiredOrganisationFields = <
  T extends Record<string, unknown>,
>(
  payload: T,
  source: Partial<OrganisationInterface>
): T => {
  const result: Record<string, unknown> = { ...payload }

  REQUIRED_ORGANISATION_UPDATE_FIELDS.forEach((field) => {
    if (result[field] == null) {
      result[field] = source[field] ?? ''
    }
  })

  return result as T
}
